export function refineFieldDeadline(config, context, path) {
    if (config.onMiss !== undefined && config.phase !== 'beforeStart') {
        context.addIssue({
            code: 'custom',
            message: 'Only a before-start field can set what happens when it is missed.',
            path: [...path, 'onMiss'],
        });
    }
    if (config.graceHours !== undefined && config.phase !== 'afterStart') {
        context.addIssue({
            code: 'custom',
            message: 'Only an after-start field can set a grace period.',
            path: [...path, 'graceHours'],
        });
    }
}
//# sourceMappingURL=refine-field-deadline.js.map